// Original values and PriceDescriptorID remain in their stated units.
export function pricePerPound(value: any, descriptor: any): number | null {
  if(value == null || String(value).trim() === '') return null;
  const n=Number(value);
  if(!Number.isFinite(n)) return null;
  const pounds=Number(descriptor)===1 ? 1 : Number(descriptor)===2 ? 101.41264060504368 : Number(descriptor)===3 ? 2204.6226218487757 : null;
  return pounds===null ? null : Math.round((n/pounds + Number.EPSILON)*10000)/10000;
}
